import { useEffect, useState } from 'react';
import { checkValue } from 'src/components/common/helper';

export function useHashFragment(offset = 0, trigger = true) {
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  useEffect(() => {
    // Check if there’s a hash in the URL
    const { hash } = window.location;
    if (!hash) return; // Exit if no hash present

    const handlePageLoad = () => {
      setIsPageLoaded(true);
    };

    // Wait for the DOM to be fully loaded
    if (hash.includes('Q:')) {
      // Listen for DOMContentLoaded, which fires when HTML is fully parsed
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handlePageLoad);
      } else {
        handlePageLoad(); // If already ready, set directly
      }

      return () => {
        document.removeEventListener('DOMContentLoaded', handlePageLoad);
      };
    } else {
      // Only add the load event listener if there is a hash
      window.addEventListener("load", handlePageLoad);

      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener("load", handlePageLoad);
      };
    }


  }, []);

  useEffect(() => {
    if (!isPageLoaded || typeof window === 'undefined') return;

    const { hash } = window.location;
    if (!checkValue(hash)) return;

    const scrollToSection = (id) => {
      const headerOffsetHeight = document.querySelector<HTMLElement>('.header-main-container')?.offsetHeight || document.querySelector<HTMLElement>('.v3-navigation')?.offsetHeight || 0;
      const currentModule = document.getElementById(id);
      if (!currentModule) return;

      // Smooth scroll to adjusted position with header offset
      window.scrollTo({
        behavior: 'smooth',
        top: currentModule.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          headerOffsetHeight - offset,
      });
    };

    const getElementById = (hash) => hash.replace('#', '').replace('Q:', '');

    const scrollToHashElement = () => {
      if (!checkValue(hash)) return;

      scrollToSection(getElementById(hash));

      // Secondary adjustment after slight delay if needed
      setTimeout(() => scrollToSection(getElementById(hash)), 100);
    };

    if (trigger) {
      setTimeout(scrollToHashElement, 500);
    }

    window.addEventListener('hashchange', scrollToHashElement);

    return () => {
      window.removeEventListener('hashchange', scrollToHashElement);
    };
  }, [isPageLoaded, offset, trigger]);
}
